// Who has the ball on a ContentIQ build package (Phase B round 3). One chip
// per holder — a package with pages on both sides shows both — plus the age
// line, red once overdue. Purely presentational: the backend computes the
// ball, src/utils/packageStatus.js words it for the viewer.
//
// Props: ball [{holder, pages, business_days, overdue}], perspective
// ('pm' | 'builder' — the same ball reads "You" to whoever holds it),
// names (optional {pm, builder, client} — ballNames() in packageStatus.js;
// wins over perspective), showAge (default true).
import React from 'react';
import { INK, HUES, STATE, RADII } from '../utils/wizardTheme';
import { ballAgeText, holderLabel } from '../utils/packageStatus';

const TONES = {
  pm: [STATE.gate.deep, STATE.gate.tint, STATE.gate.border],
  builder: [HUES.strategy.main, HUES.strategy.tint, HUES.strategy.border],
  client: [HUES.scripts.deep, HUES.scripts.tint, HUES.scripts.border],
};

export default function CiqBallChips({ ball, perspective = 'pm', names = null, showAge = true }) {
  if (!ball || !ball.length) return null;
  const oldest = ball.reduce((a, b) => ((b.business_days ?? -1) > (a.business_days ?? -1) ? b : a), ball[0]);
  const age = ballAgeText(oldest);
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: '3px' }}>
      <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '5px' }}>
        {ball.map(b => {
          const [fg, bg, border] = TONES[b.holder] || TONES.pm;
          const label = holderLabel(b.holder, perspective, names);
          return (
            <span key={b.holder} style={{ fontSize: '12px', fontWeight: 700, padding: '3px 9px',
              borderRadius: RADII.pill, color: fg, background: bg, border: `1px solid ${border}`,
              whiteSpace: 'nowrap' }}>
              {label}{ball.length > 1 && b.pages ? ` · ${b.pages} page${b.pages === 1 ? '' : 's'}` : ''}
            </span>
          );
        })}
      </span>
      {showAge && age && (
        <span style={{ fontSize: '11.5px', fontWeight: oldest.overdue ? 700 : 400,
          color: oldest.overdue ? STATE.danger.text : INK.secondary }}>{age}</span>
      )}
    </span>
  );
}
